import React, {forwardRef} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";

const RegionsItemBrowser = forwardRef(({...restProps}, ref) => {

    function getItemSubtitle(item) {
        return restProps.refsData?.countries?.[item.country_id]?.name ?? "?";
    }

    function getItemUptitle(item) {
        return item.is_region_city ? "город-регион" : undefined;
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemSubtitleFunc={getItemSubtitle}
            getItemUptitleFunc={getItemUptitle}
        />
    );
});

export default RegionsItemBrowser;